import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountSentimentReportTimeSeriesAggregateRootMapper } from '../../../infrastructure/mappers/sentiment/account-sentiment-report-time-series-aggregate-root.mapper';
import { GetAccountSentimentReportTimeSeriesRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-time-series.request.dto';
import { GetAccountSentimentReportTimeSeriesResponseDto } from '../../dtos/sentiment/get-account-sentiment-report-time-series.response.dto';
import { GetAccountSentimentReportTimeSeriesQuery } from '../../queries/sentiment/get-account-sentiment-report-time-series.query';

export class GetAccountSentimentReportTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportTimeSeriesQuery,
    protected readonly mapper: AccountSentimentReportTimeSeriesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportTimeSeriesRequestDto
  ): Promise<GetAccountSentimentReportTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
